import { Component } from '@angular/core';
import PopupHelper from '../../models/popupHelper';
import BrowserWindowObjectService from '../../services/browserWindowObjectService';
import { ConfirmResult } from '../../models/alertifyPromise';
import { Router, ActivatedRoute} from '@angular/router';
import { SortList } from '../../models/index';
import { MessageQueService } from '../../services/index';

export enum list {
  jurisdiction = 'jurisdiction',
  requestDt = 'dis_RequestDt_sort',
  status = 'isLate',
  referenceName = 'refName',
  ascending = '+',
  descending = '-'
}

@Component({
  templateUrl: 'sortTaskList.component.html',
  styleUrls: ['sortTaskList.component.scss'],
  providers: [ MessageQueService]
})

export class SortTaskListComponent {
  model: any = {};
  sortList: SortList;
  result: string;
  config: string [];

  constructor(private router: Router, private route: ActivatedRoute, private bwObjectService: BrowserWindowObjectService,
    private msgSvc: MessageQueService) {
    this.model.defaultSort1 = '0';
    this.model.defaultSort2 = '1';
    this.model.defaultSort3 = '3';
    this.model.defaultOrder1 = '0';
    this.model.defaultOrder2 = '0';
    this.model.defaultOrder3 = '0';
    this.sortList = new SortList;

    this.route.params.subscribe(params => {
      this.model.requestType = params['status'];
    });
  }

  displaySortedTaskList() {
    this.config = [this.getSortOrder(this.model.defaultOrder1) + this.getSortValue(this.model.defaultSort1)];
    this.config.push(this.getSortOrder(this.model.defaultOrder2) + this.getSortValue(this.model.defaultSort2));
    this.config.push(this.getSortOrder(this.model.defaultOrder3) + this.getSortValue(this.model.defaultSort3));
    this.config.push(`+caseNbr`);
    this.msgSvc.saveSortOrder(JSON.stringify(this.config));
    this.msgSvc.saveSortType('sorting');
    this.router.navigate(['researcherTaskList', this.model.requestType]);
  }
  goToNavigation() {
    this.router.navigate(['navigation']);
  }
  async exitDialog() {
    const confirmResult = await PopupHelper.exitSystemHelper();

    if (confirmResult === ConfirmResult.Ok) {
      this.router.navigate(['exit']);
    }
  }
  getSortValue(value: string): string {
    switch (value) {
      case '0': {
        this.result = list.jurisdiction;
        break;
      }
      case '1': {
        this.result = list.requestDt;
        break;
      }
      case '2': {
        this.result = list.status;
        break;
      }
      case '3': {
        this.result = list.referenceName;
        break;
      }
      default: {
      }
    }
    return this.result;
  }
  getSortOrder(order: string): string {
    switch (order) {
      case '0': {
        this.result = list.ascending;
        break;
      }
      case '1': {
        this.result = list.descending;
        break;
      }
      default: {
      }
    }
    return this.result;
  }
  support() {
    PopupHelper.support();
  }
  about() {
    PopupHelper.systemVersion();
  }
  help() {
    this.bwObjectService.openWindowInNewWindowByRoute(`sortTaskListHelp`, '', 800, 500);
  }
}



// WEBPACK FOOTER //
// ./src/app/sortTaskList/sortTaskList.component.ts